import form from '../components/form'

(function () {
  form.enableLabelAnimation({ elements: '.form.form--contact .input' });

  form.enableLabelAnimation({ elements: '.form.form--contact .textarea' });
})();
